import API from './API.js'
import axios from 'axios'

export default class Exams extends API {
  constructor() {
    super('exams')
  }
  async getQuestions(id) {
    const response = await axios.get(`/myExam/getQuestions/${id}`)
    return response.data.questions.sort(function (a, b) {

      return a.pivot.position - b.pivot.position;
    });
  }
  async getEduCourseProgramsExams(params) {
    const response = await axios.get(`/exams/get-educourse-programs-exams`, { params })
    return response.data;

  }
  //
  async addNewQuestion(params) {
    const response = await axios.post(`/examsQuestions/addNewQuestion`, params)
    return response;
  }
  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers, 
       * and you may want to customize it to your needs
       */
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }
}
